module.exports = __webpack_public_path__ + "static/3A841E_4_0-5313a9d698c65893896f4e405b565dbb.eot";